import { Image } from '@gyym/ui'
import React from 'react'

import { Container, Text } from './styles'

export interface FacilityLpBannerProps {
  className?: string
  utmCampaign: string
}

export const FacilityLpBanner = ({
  className,
  utmCampaign,
}: FacilityLpBannerProps) => (
  <Container
    href={`https://service.gyym.jp/facility2?utm_source=gyym.jp&utm_campaign=${utmCampaign}`}
    target="_blank"
    className={className}
  >
    <Image
      src="/assets/images/banner/facility_banner_img.png"
      alt="スマホのイラスト"
      height={60}
      width={45}
    />

    <Text>
      GYYMへの提携・掲載を
      <br />
      お考えの施設様はこちら
    </Text>
  </Container>
)
